import { render, staticRenderFns } from "./ConnoisseurEdit.vue?vue&type=template&id=07c110ba&scoped=true&"
import script from "./ConnoisseurEdit.vue?vue&type=script&lang=js&"
export * from "./ConnoisseurEdit.vue?vue&type=script&lang=js&"
import style0 from "./ConnoisseurEdit.vue?vue&type=style&index=0&id=07c110ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c110ba",
  null
  
)

export default component.exports